import routerOptions0 from "/home/runner/work/onenews/onenews/web-services/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.13.1_aws4fetch@1.0.20_db0@0.3.1_encoding@0.1_ikbqvfedw3bctjjoooabuu5g4y/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}